module.exports = __webpack_public_path__ + "img/gyuszigumi3.bbb3987e.jpg";